require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./das-naechste-stockwerk.json") })
        }
      }, "path---das-naechste-stockwerk");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---das-naechste-stockwerk!./.cache/json/das-naechste-stockwerk.json
// module id = 414
// module chunks = 231608221292675